import React from 'react';
import Form from '../../../../components/forms/utils/Form';
import SingleLineField from '../../../../components/forms/SingleLineField';
import { useMutation } from '@apollo/client';
import { UPDATE_WEBSITE } from '../../../../utils/api/website';
import { useOutletContext } from 'react-router-dom';

import DropdownField from '../../../../components/forms/DropdownField';
import { useWatch } from 'react-hook-form';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import CodeBlock from '../../../../components/CodeBlock';

const PATH_PLACEHOLDER = "path-prefix"
const InlineLink = ({href}: {href: string}) => <a className='text-indigo-600 no-underline underline-offset-4
 decoration-dotted hover:text-indigo-500 hover:underline' href={href} rel='noreferrer' target='_blank'>{href} <sup><ArrowTopRightOnSquareIcon className="h-4 w-4 inline align-text-top	" /></sup></a>

const ConfigurationHelp = ({ website }: any) => {
  const hostingType = useWatch({ name: 'hostingType' })
  const path = useWatch({ name: 'path' })

  if (hostingType !== "PATH") {
    return <>
    <p>Your testing URL for advertorial site is <InlineLink href={website.advertorialInternalUrl} />. You can check how it looks with a content using this test page: <InlineLink href={`${website.advertorialInternalUrl}test-contimo-integration`}/></p>
    <p className='mt-3'><strong>This is not intended for a production use.</strong> You need to choose another hosting type and follow the implementation guide</p>
    </>
  }

  const config = `location /${path||PATH_PLACEHOLDER}/ {\n\tproxy_pass ${website.advertorialInternalUrl};\n\tproxy_set_header X-Contimo-Token "${website.contimoToken}";\n}`

  return <>
    <p>To integrate <b>Contimo</b> to your website, you need to route all requests that go to <code className='bg-gray-800 text-white rounded-lg p-1'>{path||PATH_PLACEHOLDER}</code> "folder" to <code>{website.advertorialInternalUrl}</code> path. Here is Nginx configuration for you</p>
    <CodeBlock value={config} />
    <p className='mt-3'>To check if you configured your webserver correctly you can open this page: <InlineLink href={`${website.url.replace(/\/+$/, '')}/${path}/test-contimo-integration`} /></p>
    
    <p className='mt-6'>To improve content indexing by Google and other crawlers, update your <code className='bg-gray-800 text-white rounded-lg p-1'>robots.txt</code> and include the following line:</p>

    <CodeBlock value={`Sitemap: ${website.url.replace(/\/+$/, '')}/${path}/sitemap.xml`} />
  </>
}


const Path = () => {
  const hostingType = useWatch({ name: 'hostingType' })

  if (hostingType !== 'PATH') {
    return <></>
  }

  return <SingleLineField
    label={"Path prefix"}
    htmlfor="path"
    placeholder={PATH_PLACEHOLDER}
    required
  />
}

const hostingTypes = [
  { value: 'CONTIMO_DOMAIN', label: 'Contimo domain (test only)' },
  { value: 'PATH', label: 'Path on website' }
]


const AdvertorialHosting = () => {
  const { website } = useOutletContext<any>();

  const { __typename, ...defaultValues } = website.advertorialSite || {}

  const [updateWebsite] = useMutation(UPDATE_WEBSITE)

  const handleSubmit = async (advertorialSite: any) => {
    updateWebsite({
      variables: { id: website._id, record: { advertorialSite } }
    })
  }

  const handleSelfHostedSubmit = async (record: any) => {
    updateWebsite({ variables: { id: website._id, record } })
  }

  if (website.allowSelfHostedAdvertorials) {
    return (
      <Form
        defaultValues={{ ctaButtonSelector: website.ctaButtonSelector }}
        className='mt-8 flex-1 relative overflow-y-auto focus:outline-none bg-white rounded-md py-6 px-6'
        onSubmit={handleSelfHostedSubmit}
        submitButtonText='Save'
      >
        <SingleLineField
          top
          label='CTA buttons selector'
          htmlfor='ctaButtonSelector'
        />
      </Form>
    )
  }

  return (
    <Form
      defaultValues={defaultValues}
      className="mt-8 flex-1 relative overflow-y-auto focus:outline-none bg-white rounded-md py-6 px-6"
      onSubmit={handleSubmit}
      submitButtonText="Save"
    >
      <DropdownField
        top
        label="Hosting type"
        options={hostingTypes}
        htmlfor="hostingType"
        required
      />
      <Path />

      <ConfigurationHelp website={website}/>
    </Form>
  );
};

export default AdvertorialHosting;


